import { xcss, Box } from '@atlaskit/primitives';
import { FormattedMessage } from 'react-intl';
import { useToken } from '../../../../../Flow/ConsentContextProvider';
import { headlineMessages } from '../messages';

const headlineTextStyles = xcss({
  margin: 'space.0',
  font: 'font.heading.large',
});

interface HeaderProps {
  product?: string;
}

const Header = ({ product = 'Atlassian' }: HeaderProps) => {
  const { clientName } = useToken();

  return (
    <Box as="h1" xcss={headlineTextStyles}>
      <FormattedMessage
        {...headlineMessages.title}
        values={{ requestingParty: clientName, product }}
      />
    </Box>
  );
};

export default Header;
